/* assets/utm-discount.js */
(function () {
  // Mapowanie kampanii → kody rabatowe
  const campaignToDiscount = {
    "tiktokkredkapromo20": "tiktokkredkapromo20",
    "metakredkapromo20": "metakredkapromo20",
    "meta_rem_balance20": "meta_rem_balance20",
    "meta_adv_balance20": "meta_adv_balance20",
    "meta_rem_lift20": "meta_rem_lift20",
    "meta_adv_lift20": "meta_adv_lift20",
    "meta_rem_skin25": "meta_rem_skin25",
    "meta_adv_blur_20": "meta_adv_blur_20",
    "meta_adv_matt20": "meta_adv_matt20",
    "meta_adv_lash20": "meta_adv_lash20",
    "fb_rem_renew_rabat20": "uUA31ywt7Y",
    "adwelc_pl-eb-land-gdn-rem-20proc": "adwelc_pl-eb-land-gdn-rem-20proc",
    "fb_eleverlash_rem_rabat20": "fb_eleverlash_rem_rabat20",
    "fb_supreme_rem_rabat20": "fb_supreme_rem_rabat20",
    "fb_rem_blurfix_rabat20": "fb_rem_blurfix_rabat20",
    "fb_rem_lash15": "fb_rem_lash15",
    "adwelever_pl-remodzywka": "adwelever_pl-remodzywka",
    "adwelever_pl-rempuder": "adwelever_pl-rempuder",
    "adwelever_pl-rempodklad": "adwelever_pl-rempodklad",
    "adwelever_pl-yt_blur2607": "adwelever_pl-yt_blur2607",
    "adwelever_pl-yt_sunny2607": "adwelever_pl-yt_sunny2607",
    "adwelever_pl-yt_trio2607": "adwelever_pl-yt_trio2607",
    "adwelever_pl-yt_renew2607": "adwelever_pl-yt_renew2607",
    "adwelever_pl-rem-shine": "adwelever_pl-rem-shine",
    "fb_rem_blurfix_20_09_24": "fb_rem_blurfix_20_09_24",
    "fb_rem_supreme_20_09_24": "fb_rem_supreme_20_09_24",
    "fb_rem_eleverlash_20_09_24": "fb_rem_eleverlash_20_09_24",
    "adwelever_pl-rem-tusz": "adwelever_pl-rem-tusz",
    "fb_rem_blurfix_10.10": "fb_rem_blurfix_10.10",
    "meta_rem_tusz_17.10": "meta_rem_tusz_17.10",
    "meta_rem_lash20": "meta_rem_lash20",
    "meta_rem_matt20": "meta_rem_matt20",
    "meta_rem_supreme25": "meta_rem_supreme25",
    "meta_rem_lash25": "meta_rem_lash25",
    "pianka_cc": "pianka_cc",
    "piankasolometa20": "piankasolometa20",
    "piankarerawicameta20": "piankarerawicameta20",
    "piankasolotiktok20": "piankasolotiktok20",
    "piankarerawicatiktok20": "piankarerawicatiktok20",
    "cc_butter": "cc_butter",
    "magda_cc": "magda_cc",
    "cc_magda": "cc_magda",
    "kamila38": "kamila38"
  };

  const params = new URLSearchParams(window.location.search);
  const campaign = params.get("utm_campaign");
  const retProm = params.get("retProm");
  const continueProm = params.get("continueProm");

  let discountCode = null;

  // 1. Jeśli jest retProm=1 → kod = retProm1
  if (retProm === "1") {
    discountCode = "retProm1";
  }

  // 2. Jeśli jest continueProm=1 → kod = continueProm
  else if (continueProm === "1") {
    discountCode = "continueProm";
  }

  // 3. W innym wypadku patrzymy na utm_campaign
  else if (campaign && campaignToDiscount[campaign]) {
    discountCode = campaignToDiscount[campaign];
  }

  if (discountCode) {
    window.location.href = "/discount/" + discountCode;
  }
})();
